<template>
  <div class="block-blurb">
    <p class="blurb-label" v-if="block.content.label">{{ block.content.label }}</p>
    <h3 class="blurb-title" v-if="block.content.title">{{ block.content.title }}</h3>
    <p class="blurb-text" v-if="block.content.text">{{ block.content.text }}</p>
    <a v-if="block.content.link" :href="block.content.link" class="blurb-link">→</a>
  </div>
</template>

<script setup>
defineProps(['block'])
</script>

<style scoped>
.block-blurb {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.blurb-label {
  font-size: 0.85rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  opacity: 0.5;
  margin: 0;
}

.blurb-title {
  font-size: clamp(1.25rem, 2.5vw, 2rem);
  line-height: 1.1;
  margin: 0;
}

.blurb-text {
  line-height: 1.5;
  max-width: 40em;
  margin: 0;
}

.blurb-link {
  align-self: flex-start;
}
</style>
